module.exports = __webpack_public_path__ + "img/4.43623275.png";